import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { InfoStripeData, Query } from '@Types/Base';

export interface Response {
  ok: boolean;
  data: InfoStripeData;
}

async function getInfoStripe(request: Query) {
  const {
    region,
    country,
    language: { id: lang },
  } = request;
  let url = `/promo/info-stripe`;
  const params = new URLSearchParams();
  params.set('region', region);
  params.set('country', country);
  params.set('lang', lang);

  url += `?${params.toString()}`;

  const res = await Api.queryProxi<Response>(
    url,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    request,
  );

  if (!res.ok) throw new BackendError(url, res);

  return res.data;
}

export default getInfoStripe;
